import React, { useState } from 'react'
import { Card, Col, Form, Input, InputNumber, List, Popconfirm, Row } from 'antd';
import systemConfig from '../../../config/systematic';
import fetchApi from '../../../utils/api/fetchApi';
import antMessage from '../../../utils/extend/AntdNotification';
export default function VerifyVoucher(props: any) {
  const [form] = Form.useForm(); //form 
  const [rows, setRows] = useState<Array<any>>([])
  /** 后端数据wmService */
  let wmService: any = systemConfig.wmService;
  const [quantities, setQuantities] = useState<any>({});
  const { Search } = Input;
  const handleOk = (e: any) => {
    // setIsLoading(true)
    form.validateFields() //数据校验
      .then(async (values: any) => {
        fetchApi.GET(wmService, {
          apiId: "giftCard",
          apiExtend: "retrieveList",
          apiVariable: values.giftCardId,
        }).then((res) => {
          console.log("res", res);

          if (res.success) {
            if (res.data.length > 0) {
              let newData = groupDataByAssociationId(res.data);
              setRows(newData)
              setQuantities({});
              antMessage("success", "查询成功!!");
            }
          } else {
            antMessage("error", "查询失败!!", res.data.message);
          }
        }).catch((err) => {
          antMessage("error", "查询失败!!", JSON.stringify(err));
        })


      })
      .catch((err: any) => {

        const { errorFields } = err;
        let errors = errorFields[0].errors[0]

      });
  }
  // 独立的分组函数
  const groupDataByAssociationId = (dataArray: Array<any>) => {
    return dataArray.reduce((accumulator, currentItem) => {
      const { associationId, giftCardStatus, giftCardPlans, id, redemptionCode } = currentItem;

      // 查找是否已存在该associationId的分组
      const existingGroup = accumulator.find((group: any) => group.associationId === associationId);

      if (existingGroup) {
        // 如果分组已存在，增加counts并添加id到ids数组
        // existingGroup.counts += 1;
        existingGroup.ids.push(id);
      } else {
        // 如果分组不存在，创建新分组
        accumulator.push({
          associationId,
          // counts: 1,
          redemptionCode,
          faceValue: giftCardPlans.faceValue,
          planName: giftCardPlans.planName,
          giftCardStatus: giftCardStatus.name,
          ids: [id]
        });
      }

      return accumulator;
    }, []);
  };


  const redeem = (apiData: any) => {
    const quantity = quantities[apiData.associationId] || 1; // 获取当前菜单项对应的数量
    let ids = apiData.ids;
    let newIds = ids.slice(0, quantity)

    fetchApi.PUT(wmService, {
      apiId: "giftCard",
      apiExtend: "redeem",
      apiData: {
        ids: newIds,
        redemptionCode: apiData.redemptionCode,
        mountDataOptions: {userMount: {isDept: true }}
      }
    }).then((res) => {
      if (res.success) {
        setRows([])
        setQuantities({})
        antMessage("success", "核销成功!");
      } else {
        antMessage("error", "核销失败!");
      }

    }).catch((err) => {
      antMessage("error", "核销失败!", JSON.stringify(err));
      console.log("err", err);

    })


  }

  return (
    <div>
      <Form
        form={form}
        name="Edit"
        onFinish={handleOk}
      // onKeyDown={(e: any) => {
      //   if (e.key === 'Enter') {
      //     handleOk(e)
      //   }
      // }}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="礼品卡Id"
              tooltip={"使用礼品卡Id查询"}

              name="giftCardId">
              <Search
                // addonBefore="https://"
                // placeholder="input search text"
                allowClear
                onSearch={handleOk}
                style={{ width: 304 }}
              />
              {/* <Input placeholder='使用礼品卡Id查询'></Input> */}
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <List
        itemLayout="horizontal"
        grid={{ gutter: 16, column: 4 }}
        dataSource={rows}
        // position
        renderItem={(menu: any) => {
          return (
            <List.Item>
              <Card
                title={
                  <>
                    <div style={{ justifyContent: "space-between", display: "flex", fontSize: 15 }}>
                      <div>{menu.planName}</div>
                      <div>一共:{menu.ids?.length}张</div>

                    </div>
                  </>
                }
                actions={[
                  <> <InputNumber min={1} onChange={(value) => {
                    setQuantities((prev: any) => ({
                      ...prev,
                      [menu.associationId]: value
                    }));
                  }} defaultValue={1} max={menu.ids?.length}
                    // addonBefore={<div onClick={()=>redeem(menu)}>核销张数</div>}
                    addonBefore={<Popconfirm title="确定要核销吗？" onConfirm={() => redeem(menu)} okText="确定" cancelText="取消">
                      <div className='exit'  >核销张数</div>
                    </Popconfirm>}
                  ></InputNumber></>
                ]}
              >
                <div style={{ justifyContent: "space-between", display: "flex", fontSize: "18px" }}>
                  <div>面值:{menu.faceValue}</div>
                </div>
                {/* <div style={{ justifyContent: "space-between", display: "flex", fontSize: "18px" }}>
                  <div >{`余额:${menu.balance}`}</div>
                  <div>{`赠送余额:${menu.gifts}`}</div>
                  <div>{`积分:${menu.points}`}</div>
                </div> */}


              </Card>
            </List.Item>
          )
        }}
      />
    </div>
  )
}
